import React, { useState, useRef, forwardRef, useImperativeHandle } from 'react';
import cn from 'classnames';
import "./Tabs.css";
var styles = { "tabs": "de8f85", "tablist": "b68f81", "tab": "db1c40", "tab_fixed": "e98e76", "tab_fixed_wrap": "c6fcea", "tab_fixed_nospacing": "daf708", "tab_clustered": "f84654", "tab_active": "a7b78f", "panel": "c20014" };
const Tabs = forwardRef(({ tabs, className, defaultActiveTab = 0, variant = 'fixed', ariaLabel, onClick, testId }, ref) => {
    const { dir } = document;
    const [activeTab, setActiveTab] = useState(defaultActiveTab);
    const tabRefs = useRef([]);
    const tablistRef = useRef(null);
    useImperativeHandle(ref, () => tablistRef.current);
    const handleRef = (element, index) => {
        if (element) {
            tabRefs.current[index] = element;
        }
    };
    const handleOnClick = (tabId) => {
        setActiveTab(tabId);
        if (onClick) {
            onClick(tabId);
        }
    };
    const handleOnKeyDown = (event, index) => {
        if (event.key === 'ArrowRight') {
            if (dir === 'ltr') {
                if (tabRefs.current[index + 1]) {
                    tabRefs.current[index + 1].focus();
                }
                else {
                    tabRefs.current[0].focus();
                }
            }
            if (dir === 'rtl') {
                if (tabRefs.current[index - 1]) {
                    tabRefs.current[index - 1].focus();
                }
                else {
                    tabRefs.current[tabRefs.current.length - 1].focus();
                }
            }
        }
        if (event.key === 'ArrowLeft') {
            if (dir === 'ltr') {
                if (tabRefs.current[index - 1]) {
                    tabRefs.current[index - 1].focus();
                }
                else {
                    tabRefs.current[tabRefs.current.length - 1].focus();
                }
            }
            if (dir === 'rtl') {
                if (tabRefs.current[index + 1]) {
                    tabRefs.current[index + 1].focus();
                }
                else {
                    tabRefs.current[0].focus();
                }
            }
        }
    };
    return (React.createElement("div", { className: cn(styles.tabs, className) },
        React.createElement("div", { className: styles.tablist, role: "tablist", "aria-label": ariaLabel, tabIndex: -1, ref: tablistRef, "data-testid": testId }, tabs.map((tab, index) => (React.createElement("button", { type: "button", key: `tab-${tab.id}`, className: cn(styles.tab, activeTab === tab.id && styles.tab_active, styles[`tab_${variant}`], variant === 'fixed' && tabs.length >= 3 && styles.tab_fixed_nospacing), role: "tab", "aria-selected": activeTab === tab.id, "aria-controls": `panel-${tab.id}`, id: `tab-${tab.id}`, tabIndex: tab.id === activeTab ? 0 : -1, ref: (element) => {
                handleRef(element, index);
            }, onClick: () => {
                handleOnClick(tab.id);
            }, onKeyDown: (event) => {
                handleOnKeyDown(event, index);
            } },
            React.createElement("span", { className: cn(variant === 'fixed' && tabs.length < 3 && styles.tab_fixed_wrap) }, tab.label))))),
        tabs.map((tab) => (React.createElement("div", { className: styles.panel, key: `panel-${tab.id}`, id: `panel-${tab.id}`, role: "tabpanel", tabIndex: 0, "aria-labelledby": `tab-${tab.id}`, hidden: activeTab !== tab.id }, tab.content)))));
});
export default Tabs;
//# sourceMappingURL=Tabs.js.map